import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-fright-service',
  templateUrl: './air-fright-service.component.html',
  styleUrls: ['./air-fright-service.component.scss']
})
export class AirFrightServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
